(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rLoginDCentProvider", [], factory);
	else if(typeof exports === 'object')
		exports["rLoginDCentProvider"] = factory();
	else
		root["rLoginDCentProvider"] = factory();
})(this, function() {
return 